function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop---Sidor",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1125.000000, -37.000000)",
  stroke: "#333333"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1125.000000, 37.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5
}), /*#__PURE__*/React.createElement("polyline", {
  points: "11.3066406 2.34375 11.3066406 8.73925781 17.5693359 8.73925781"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(5.372272, 14.118639) rotate(180.000000) translate(-5.372272, -14.118639) ",
  points: "2.2409248 10.9208847 2.2409248 17.3163925 8.50362012 17.3163925"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(5.437988, 5.541504) rotate(-90.000000) translate(-5.437988, -5.541504) ",
  points: "2.30664062 2.34375 2.30664062 8.73925781 8.56933594 8.73925781"
}), /*#__PURE__*/React.createElement("polyline", {
  transform: "translate(14.370902, 14.275710) rotate(90.000000) translate(-14.370902, -14.275710) ",
  points: "11.2395541 11.0779564 11.2395541 17.4734642 17.5022494 17.4734642"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.75,
  y1: 15.4470215,
  x2: 8.25,
  y2: 10.8156738
}), /*#__PURE__*/React.createElement("line", {
  x1: 11.75,
  y1: 8.44702148,
  x2: 16.25,
  y2: 3.81567383
}), /*#__PURE__*/React.createElement("line", {
  x1: 8.63134766,
  y1: 8.5,
  x2: 4,
  y2: 4
}), /*#__PURE__*/React.createElement("line", {
  x1: 15.6313477,
  y1: 15.5,
  x2: 11,
  y2: 11
})))));
var SvgIconFlagEn = function SvgIconFlagEn(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFlagEn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-flag-en.727dff65.svg";
export { ForwardRef as ReactComponent };